import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import './ItemPage.css';
import userPlaceholder from '../assets/usuario.png';
import { useCart } from '../context/CartContext.jsx'; // <-- Import al principio

const ItemPage = () => {
  const [product, setProduct] = useState(null);
  const [sellerInfo, setSellerInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [quantity, setQuantity] = useState(1);
  const { productId } = useParams();
  const { addToCart } = useCart();

  // --- EFECTO 1: BUSCAR EL PRODUCTO ---
  useEffect(() => {
    const fetchProduct = async () => {
      setLoading(true);
      setSellerInfo(null);
      setError('');
      try {
        const response = await fetch(`https://tech-market-ba-back.vercel.app/products/approved/${productId}`);
        if (!response.ok) throw new Error('Producto no encontrado');
        const data = await response.json();
        setProduct(data);
      } catch (err) {
        setError(err.message);
        console.error("Error al buscar el producto:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchProduct();
  }, [productId]);

  // --- EFECTO 2: BUSCAR AL VENDEDOR ---
  useEffect(() => {
    const fetchSellerInfo = async () => {
      if (product && product.id_user) {
        try {
          const response = await fetch(`https://tech-market-ba-back.vercel.app/users/public/${product.id_user}`);
          if (response.ok) {
            const sellerData = await response.json();
            setSellerInfo(sellerData);
          } else {
            setSellerInfo({ name: 'Vendedor Desconocido', avatar: null });
          }
        } catch (err) {
          console.error("Error al buscar el vendedor:", err);
          setSellerInfo({ name: 'Vendedor (Error)', avatar: null });
        }
      }
    };

    fetchSellerInfo();
  }, [product]);

  // --- HANDLERS ---
  const handleAddToCart = () => {
    if (product) {
      addToCart(product, quantity);
    }
  };

  const handleQuantityChange = (e) => {
    let newQuantity = parseInt(e.target.value, 10);
    if (isNaN(newQuantity) || newQuantity < 1) newQuantity = 1;
    if (product && newQuantity > product.stock) newQuantity = product.stock;
    setQuantity(newQuantity);
  };
  
  if (loading) return <div className="loading-message">Cargando producto...</div>;
  if (error) return <div className="error-message">{error}</div>;
  if (!product) return null;
  
  return (
    <div className="item-page-container">
      <div className="product-main-section">
        <div className="product-gallery">
          <img 
            src={product.images?.[0] || 'https://via.placeholder.com/400'} 
            alt={product.name} 
            className="main-image" 
          />
        </div>
        <div className="product-details">
          <h1 className="product-title">{product.name}</h1>
          <p className="product-stock">{product.stock} disponibles</p>
          <p className="product-price">${product.price.toLocaleString('es-AR')}</p>
          <div className="product-actions">
            <input 
              type="number" 
              value={quantity} 
              onChange={handleQuantityChange} 
              min="1" 
              max={product.stock} 
              className="quantity-input" 
            />
            <button className="buy-now-button">Comprar ahora</button>
            <button 
              className="add-to-cart-button"
              onClick={handleAddToCart}
            >
              Agregar al carrito
            </button>
          </div>
        </div>
      </div>

      <div className="product-info-layout">
        <div className="left-column">
          <div className="product-description-box">
            <h3>Características del producto</h3>
            <p><strong>Marca:</strong> {product.brand}</p>
            <p><strong>Modelo:</strong> {product.model}</p>
            <p><strong>Condición:</strong> {product.condition}</p>
            <p>{product.description}</p>
          </div>
          <div className="product-reviews-box">
            <h3>Reseñas del producto</h3>
            <p>Funcionalidad de reseñas próximamente.</p>
          </div>
      </div>

        <div className="right-column">
          <div className="seller-info-box">
            {sellerInfo ? (
              <>
                <img 
                  src={sellerInfo.avatar || userPlaceholder} 
                  alt={sellerInfo.name} 
                  className="seller-avatar" 
                />
                <div>
                  <p>Vendido por <strong>{sellerInfo.name}</strong></p>
                  {product.id_user && (
                    <Link to={`/user/${product.id_user}`} className="view-profile-button">
                      Ver perfil
                    </Link>
                  )}
                </div>
              </>
            ) : (
              <p>Cargando información del vendedor...</p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemPage;